import { PROXISERVE_ELIGIBLE_ZIPCODES_BY_HEATING_TYPE, ProxiserveHeatingType } from './eligibleZipcodesByHeatingType'

interface ProxiserveEligibilityAddress {
  heatingEnergy?: string | null
  zipcode?: string | null
  energyLandscape?: {
    heatPump?: boolean
    airConditionersOneRoom?: boolean
    airConditionersMultipleRooms?: boolean
  }
}

const retrieveProxiserveHeatingTypes = (address?: ProxiserveEligibilityAddress): ProxiserveHeatingType[] => {
  if (address?.heatingEnergy === 'gas') {
    return ['gas']
  }
  if (address?.heatingEnergy === 'propane') {
    return ['propane']
  }
  if (address?.heatingEnergy === 'oil') {
    return ['oil']
  }
  if (address?.heatingEnergy === 'elec') {
    const heatingTypes: ProxiserveHeatingType[] = []
    if (address?.energyLandscape?.heatPump) {
      heatingTypes.push('heatPump')
    }
    if (address?.energyLandscape?.airConditionersOneRoom || address?.energyLandscape?.airConditionersMultipleRooms) {
      heatingTypes.push('reversibleAirConditioning')
    }
    return heatingTypes
  }
  return []
}

export const isProxiserveEligible = (address?: ProxiserveEligibilityAddress): boolean => {
  const heatingTypes = retrieveProxiserveHeatingTypes(address)
  if (heatingTypes.length === 0 || !address?.zipcode) {
    return false
  }
  const { zipcode } = address
  return heatingTypes.some(heatingType => PROXISERVE_ELIGIBLE_ZIPCODES_BY_HEATING_TYPE[heatingType].has(zipcode))
}
